"use client";

import React from "react";
import { SearchLocationForm } from "./form-with-location";
import { useSearchNavigation } from "./hooks";
import type { SearchSectionProps } from "./types";

export const SearchSection: React.FC<SearchSectionProps> = ({ className = "", isLoggedIn = false }) => {
	const { isLoading, isPending, setIsNavigating, handleSearchWithFallback, handleSearchWithCoordinates } =
		useSearchNavigation();

	// Reset navigation state when transition completes
	React.useEffect(() => {
		if (!isPending) {
			setIsNavigating(false);
		}
	}, [isPending, setIsNavigating]);

	return (
		<SearchLocationForm
			className={className}
			onSearchWithFallback={handleSearchWithFallback}
			onSearchWithCoords={handleSearchWithCoordinates}
			isLoading={isLoading}
			isLoggedIn={isLoggedIn}
		/>
	);
};

// Export types and utilities for external use
export type { PlaceDetails, SearchSectionProps } from "./types";
